document.addEventListener('DOMContentLoaded', function() {
  
  // ==========================================
  // FUNZIONE ARTISTA (TOOLTIPS IN GRIGLIA)
  // ==========================================
  const artistBtns = document.querySelectorAll('.koji-artist-btn');
  
  artistBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); 
      e.stopPropagation(); 
      const targetId = this.getAttribute('data-artist-id');
      const tooltip = document.getElementById(targetId);
      
      // Chiude tutti gli altri tooltip e resetta gli aria-expanded
      document.querySelectorAll('.koji-artist-tooltip').forEach(tt => {
        if(tt.id !== targetId) {
          tt.classList.remove('is-active');
          const relatedBtn = document.querySelector(`[data-artist-id="${tt.id}"]`);
          if(relatedBtn) relatedBtn.setAttribute('aria-expanded', 'false');
        }
      });

      // Togla il tooltip cliccato e aggiorna aria-expanded
      if (tooltip) {
        const isActive = tooltip.classList.toggle('is-active');
        this.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      }
    });
  });

  // Chiude i tooltip cliccando fuori
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.koji-artist-btn') && !e.target.closest('.koji-artist-tooltip')) {
      document.querySelectorAll('.koji-artist-tooltip').forEach(tt => tt.classList.remove('is-active'));
      document.querySelectorAll('.koji-artist-btn').forEach(btn => btn.setAttribute('aria-expanded', 'false'));
    }
  });

  // ACCESSIBILITÀ: Permette la chiusura dei tooltip con il tasto ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.koji-artist-tooltip.is-active').forEach(tt => {
        tt.classList.remove('is-active');
        const relatedBtn = document.querySelector(`[data-artist-id="${tt.id}"]`);
        if (relatedBtn) {
          relatedBtn.setAttribute('aria-expanded', 'false');
          relatedBtn.focus(); // Riporta il focus al pulsante per l'utente
        }
      });
    }
  });

});